import gql from 'graphql-tag';

export const GET_CODE_LIST = gql`
    query(
        $code_key: String!
        $default_display: Int!
    ) {
        GetCodeList(
            code_key: $code_key
            default_display: $default_display
        ) {
            CodeList{
                code_key
                code
                code_name
                code_key_name
                reserve1
                reserve2
                reserve3
                reserve4
                reserve5
                valid_flag
            }
        }
    }
`;

export const GET_ALL_CODE_LIST = gql`
    query(
        $starttime_checkbox: String
        $cells_selectbox: String
    ) {
        GetAllCodeList (
            starttime_checkbox: $starttime_checkbox
            cells_selectbox: $cells_selectbox
         ){
            CodeList{
                code_key
                code
                code_name
                code_key_name
            }
        }
    }
`;

export const GET_CODE_LIST_FOR_RESERVE = gql`
    query(
        $golf_group_code: String,
        $golf_code: String,
    ) {
        GetCodeListForReserve (
            golf_group_code: $golf_group_code
            golf_code: $golf_code
        ){
            SpecialList{
                benefit_detail
                benefit_name
                benefit_cd
            }
            CodeKeyRecList{
                codeKey
                codeRec {
                    code_key
                    code
                    code_name
                    code_key_name
                    reserve1
                    reserve2
                    reserve3
                    reserve4
                    reserve5
                    valid_flag
                }
            }
            golf_course_img_path
        }
    }
`;
